// Shared DataGrid styles for consistent theming across the application
export const getDataGridStyles = (darkMode) => ({
  '& .MuiDataGrid-root': {
    backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
    color: darkMode ? '#ffffff' : '#000000',
    border: darkMode ? '1px solid #404040' : '1px solid #e0e0e0',
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: darkMode ? '#2d2d2d' : '#f5f5f5',
    color: darkMode ? '#ffffff' : '#000000',
    borderBottom: darkMode ? '1px solid #404040' : '1px solid #e0e0e0',
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: darkMode ? '#2d2d2d' : '#f5f5f5',
    color: darkMode ? '#ffffff' : '#000000',
    '&:focus': {
      backgroundColor: darkMode ? '#2d2d2d' : '#f5f5f5',
    },
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    color: darkMode ? '#ffffff' : '#000000',
    fontWeight: 600,
  },
  '& .MuiDataGrid-row': {
    backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
    color: darkMode ? '#ffffff' : '#000000',
    '&:hover': {
      backgroundColor: darkMode ? '#2a2a2a' : '#f5f5f5',
    },
    '&.Mui-selected': {
      backgroundColor: darkMode ? '#1a3f5c' : '#e3f2fd',
      '&:hover': {
        backgroundColor: darkMode ? '#1a3f5c' : '#e3f2fd',
      },
    },
  },
  '& .MuiDataGrid-cell': {
    backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
    color: darkMode ? '#ffffff' : '#000000',
    borderBottom: darkMode ? '1px solid #404040' : '1px solid #e0e0e0',
    '&:focus': {
      backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
    },
    '&:focus-within': {
      backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
    },
  },
  '& .MuiDataGrid-footerContainer': {
    backgroundColor: darkMode ? '#2d2d2d' : '#f5f5f5',
    color: darkMode ? '#ffffff' : '#000000',
    borderTop: darkMode ? '1px solid #404040' : '1px solid #e0e0e0',
  },
  '& .MuiDataGrid-virtualScroller': {
    backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
  },
  '& .MuiDataGrid-virtualScrollerContent': {
    backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
  },
  '& .MuiDataGrid-panel': {
    backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
    color: darkMode ? '#ffffff' : '#000000',
  },
  '& .MuiDataGrid-panelContent': {
    backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
    color: darkMode ? '#ffffff' : '#000000',
  },
  '& .MuiDataGrid-panelFooter': {
    backgroundColor: darkMode ? '#2d2d2d' : '#f5f5f5',
    color: darkMode ? '#ffffff' : '#000000',
  },
  '& .MuiTablePagination-root': {
    color: darkMode ? '#ffffff' : '#000000',
  },
  '& .MuiTablePagination-select': {
    color: darkMode ? '#ffffff' : '#000000',
  },
  '& .MuiTablePagination-selectIcon': {
    color: darkMode ? '#ffffff' : '#000000',
  },
  '& .MuiTablePagination-actions': {
    color: darkMode ? '#ffffff' : '#000000',
  },
  '& .MuiIconButton-root': {
    color: darkMode ? '#ffffff' : '#000000',
    '&:hover': {
      backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
    },
  },
  '& .MuiDataGrid-columnSeparator': {
    color: darkMode ? '#404040' : '#e0e0e0',
  },
  '& .MuiDataGrid-columnSeparator--moving': {
    color: darkMode ? '#64b5f6' : '#1976d2',
  },
  '& .MuiDataGrid-sortIcon': {
    color: darkMode ? '#ffffff' : '#000000',
  },
  '& .MuiDataGrid-filterIcon': {
    color: darkMode ? '#ffffff' : '#000000',
  },
  '& .MuiDataGrid-menuIcon': {
    color: darkMode ? '#ffffff' : '#000000',
  },
  '& .MuiDataGrid-loadingOverlay': {
    backgroundColor: darkMode ? 'rgba(30, 30, 30, 0.8)' : 'rgba(255, 255, 255, 0.8)',
  },
  '& .MuiDataGrid-overlay': {
    backgroundColor: darkMode ? '#1e1e1e' : '#ffffff',
    color: darkMode ? '#ffffff' : '#000000',
  },
}); 